export default __webpack_public_path__ + "static/media/whatsapp.b1ba451a.jpeg";